import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function TwoPathsSection() {
  const badPath = ['Dietas que duran 2 semanas', 'Ropa que sigue sin cerrar', 'Energía en el piso cada mañana', 'Frustración que crece cada mes', 'Esperando que algo cambie sin cambiar la raíz del problema'];
  const goodPath = ['Despertarte con energía real antes de la alarma', 'Ponerte esa ropa guardada en el clóset', 'Mirarte al espejo y reconocerte', 'Antojos bajo control desde la semana 1', 'Tu mejor versión a 30 días de distancia'];
  return <section className="w-full bg-dark py-20 px-4" data-id="element-303">
      <div className="max-w-[960px] mx-auto" data-id="element-304">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[28px] md:text-[34px] font-bold text-white text-center mb-12" data-id="element-305">
          Hay Dos Caminos Frente a Ti en Este Momento
        </motion.h2>

        <div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-4 relative" data-id="element-306">
          {/* VS Badge (Desktop) */}
          <div className="hidden md:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-dark rounded-full items-center justify-center z-10 font-black text-white text-xl border-4 border-dark" data-id="element-307">
            VS
          </div>

          {/* Left Card - Bad Path */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-[#2D2D2D] border-2 border-urgencyRed rounded-2xl p-8 md:p-9 flex flex-col" data-id="element-308">
            <div className="flex flex-col items-center mb-8" data-id="element-309">
              <div className="w-12 h-12 rounded-full bg-urgencyRed/20 flex items-center justify-center mb-4" data-id="element-310">
                <X className="w-6 h-6 text-urgencyRed" data-id="element-311" />
              </div>
              <h3 className="text-[20px] font-bold text-urgencyRed text-center" data-id="element-312">
                Seguir Como Siempre
              </h3>
            </div>

            <ul className="space-y-4 flex-grow" data-id="element-313">
              {badPath.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-314">
                  <X className="w-5 h-5 text-urgencyRed flex-shrink-0 mt-0.5" data-id="element-315" />
                  <span className="text-[15px] text-white/75 leading-[1.6]" data-id="element-316">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* VS Badge (Mobile) */}
          <div className="md:hidden flex justify-center py-2" data-id="element-317">
            <span className="font-black text-white/50 text-xl" data-id="element-318">VS</span>
          </div>

          {/* Right Card - Good Path */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-gradient-to-b from-[#006060] to-teal border-2 border-lime rounded-2xl p-8 md:p-9 flex flex-col shadow-[0_0_30px_rgba(144,190,109,0.15)]" data-id="element-319">
            <div className="flex flex-col items-center mb-8" data-id="element-320">
              <div className="w-12 h-12 rounded-full bg-lime/20 flex items-center justify-center mb-4" data-id="element-321">
                <Check className="w-6 h-6 text-lime" data-id="element-322" />
              </div>
              <h3 className="text-[20px] font-bold text-lime text-center" data-id="element-323">
                El Protocolo Reinicio 40+
              </h3>
            </div>

            <ul className="space-y-4 flex-grow" data-id="element-324">
              {goodPath.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-325">
                  <Check className="w-5 h-5 text-lime flex-shrink-0 mt-0.5" data-id="element-326" />
                  <span className="text-[15px] text-white leading-[1.6] font-medium" data-id="element-327">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}